// import api from "../../../config/api/index.js"
// import type { ApiResponse } from "../auth/types.js"

// // core/services/admins/customer/api.ts

// interface IGetCustomerListParams {
//     search?: string
//     type?: string
//     page?: number
//     size?: number
//     sortField?: string
//     sortDirection?: "ACS" | "DESC" | string
// }

// // core/services/admins/customer/api.ts

// // ============== GET - گزارش عملکرد مشتری ==============
// export interface CustomerPerformanceParams {
//     customerId: number;
//     page?: number;
//     size?: number;
//     sortField?: string;
//     sortDirection?: 'ASC' | 'DESC';
// }
// export const UploadCustomerAverageExcel = async (
//     file: File,
//     fileName: string
// ): Promise<Blob> => {
//     try {
//         const formData = new FormData();
//         formData.append("file", file);

//         const res = await api.post(
//             "/managerPanel/importExcell/getListOfCustomersWithPlan",
//             formData,
//             {
//                 params: { fileName },           // ← برگردانده شد
//                 responseType: "blob",           // ← اضافه شد
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                     Accept: "application/octet-stream",  // ← توصیه‌شده
//                 },
//             }
//         );

//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };
// // ============================================
// // ✅ آپلود اکسل پرداخت مشتری‌ها
// // POST /api/managerPanel/importExcell/importCustomerPayments
// // ============================================
// export const ImportCustomerPaymentsExcel = async (
//     file: File,
//     fileName: string
// ): Promise<Blob> => {
//     try {
//         const formData = new FormData();
//         formData.append("file", file);

//         const res = await api.post(
//             "/managerPanel/importExcell/importCustomerPayments",
//             formData,
//             {
//                 params: { fileName },
//                 responseType: "blob",
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                     Accept: "application/octet-stream",
//                 },
//             }
//         );

//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };

// // ============================================
// // ✅ دریافت لیست مشتریان دارای مبلغ قابل پرداخت
// // GET /api/managerPanel/importExcell/listOfCustomerPayments
// // ============================================
// export const DownloadListOfCustomerPayments = async (): Promise<Blob> => {
//     try {
//         const res = await api.get(
//             "/managerPanel/importExcell/listOfCustomerPayments",
//             {
//                 responseType: "blob",
//                 headers: {
//                     Accept: "application/octet-stream",
//                 },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };
// export interface CustomerPerformanceItem {
//     id: number;
//     customer: {
//         id: number;
//         customerCode: number;
//         customerType: 'NATURAL' | 'LEGAL' | 'CHARITY';
//         naturalInfo?: {
//             nickname?: string;
//             firstName?: string;
//             lastName?: string;
//             nationalId?: string;
//             birthDate?: number;
//             gender?: 'MALE' | 'FEMALE';
//         };
//         legalInfo?: {
//             name?: string | null;
//             brand?: string | null;
//             companyNationalId?: string | null;
//             managerName?: string | null;
//             managerMobileNumber?: string | null;
//             phoneNumber?: string | null;
//             charity?: boolean;
//             employeeCount?: number;
//         };
//         mobileNumber?: string;
//         defaultVisitor?: boolean;
//         visitorSet?: boolean;
//     };
//     releaseDate: string;
//     paymentDate: string | null;
//     previousMonthAverage: number;
//     diamondReceived: number;
//     interestReceived: number;
//     benefitCardReceived: number;
//     amount: number;
//     payed: boolean;
// }

// /**
//  * دریافت Customer Performance
//  * @param params - (CustomerPerformanceParams)
//  * @returns پاسخ سرور
//  */
// export const GetCustomerPerformanceApi = async (
//     params: CustomerPerformanceParams
// ): Promise<ApiResponse<CustomerPerformanceItem[]>> => {
//     try {
//         const response = await api.get<ApiResponse<CustomerPerformanceItem[]>>(
//             `managerPanel/customer/CustomerPerformance`,
//             { params }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Failed to get customer performance:", error);
//         throw error;
//     }
// };
// /**
//  * دریافت Customer List
//  * @param {
//     search = ""
//  * @param type = "ALL"
//  * @param page = 0
//  * @param size = 25
//  * @param sortField = "id"
//  * @param sortDirection = "ASC"
//  * @param } - (IGetCustomerListParams = {})
//  * @returns پاسخ سرور
//  */
// export const GetCustomerList = async ({
//     search = "",
//     type = "ALL",
//     page = 0,
//     size = 25,
//     sortField = "id",
//     sortDirection = "ASC",
// }: IGetCustomerListParams = {}) => {
//     const params = new URLSearchParams();

//     params.append("type", type);
//     params.append("page", String(page));
//     params.append("size", String(size));
//     params.append("sortField", sortField);
//     params.append("sortDirection", sortDirection);

//     if (search.trim()) {
//         params.append("search", search.trim());
//     }

//     const res = await api.get(
//         `/managerPanel/customer/search?${params.toString()}`
//     );
//     return res.data;
// };
// // core/services/admins/customer/uploadExcel/api.ts

// // core/services/admins/customer/api.ts


// /**
//  * آپلود Customer Excel
//  * @param file - (File)
//  * @returns پاسخ سرور
//  */
// export const UploadCustomerExcel = async (
//     file: File,
//     fileName: string
// ): Promise<Blob> => {
//     const formData = new FormData();
//     formData.append("file", file);

//     const res = await api.post(
//         "/managerPanel/importExcell/openingBankAccount",
//         formData,
//         {
//             params: { fileName }, // ✅ query param
//             responseType: "blob",
//             headers: {
//                 "Content-Type": "multipart/form-data",
//                 Accept: "application/octet-stream",
//             },
//         }
//     );

//     return res.data;
// };
// /**
//  * آپلود Customer Average Visitor Excel
//  * @param file - (File)
//  * @returns پاسخ سرور
//  */
// export const UploadCustomerAverageVisitorExcel = async (
//     file: File,
//     fileName: string
// ): Promise<any> => {
//     try {
//         const formData = new FormData();
//         formData.append("file", file);

//         const res = await api.post(
//             "/managerPanel/importExcell/customerAverageVisitor",
//             formData,
//             {
//                 params: { fileName },
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                 },
//             }
//         );

//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };
// // ============================================
// // ✅ تغییر بازاریاب مشتری
// // ============================================
// /**
//  * به‌روزرسانی Customer Visitor
//  * @param customerId - (any)
//  * @param newVisitorCode - (any)
//  * @returns پاسخ سرور
//  */
// export const ChangeCustomerVisitor = async (
//     customerId: any,
//     newVisitorCode: any
// ) => {
//     try {
//         const res = await api.get(
//             "/managerPanel/customer/changeVisitor",
//             {
//                 params: { customerId, newVisitorCode },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };
// /**
//  * آپلود Average Natural Customer Excel
//  * @param file - (File)
//  * @returns پاسخ سرور
//  */
// export const UploadAverageNaturalCustomerExcel = async (
//     file: File,
//     fileName: string
// ): Promise<Blob> => {
//     try {
//         const formData = new FormData();
//         formData.append("file", file);

//         const res = await api.post(
//             "/managerPanel/importExcell/averageNaturalCustomer",
//             formData,
//             {
//                 params: { fileName },
//                 responseType: "blob",
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                 },
//             }
//         );

//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };
// /**
//  * به‌روزرسانی Customer Active
//  * @param { customerId
//  * @param status } - (any)
//  * @returns پاسخ سرور
//  */
// export const ChangeCustomerActive = async ({ customerId, status }: any) => {
//     try {
//         const res = await api.get(
//             "/managerPanel/customer/activeDeActive",
//             {
//                 params: { customerId, status },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };

// // ============================================
// // ✅ دریافت اطلاعات کامل یک مشتری
// // ============================================
// /**
//  * دریافت Customer Info
//  * @param customerId - (number)
//  * @returns پاسخ سرور
//  */
// export const GetCustomerInfo = async (customerId: number) => {
//     try {
//         const res = await api.get(
//             "/managerPanel/customer/getCustomerInfo",
//             {
//                 params: { customerId },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };

// export const ChangePasswordByAdminApi = async (data: {
//     customerId: number;
//     password: string;
// }): Promise<any> => {
//     try {
//         const response = await api.post(
//             "managerPanel/legal/changePasswordByAdmin",
//             data
//         );
//         return response.data;
//     } catch (error: any) {
//         console.error("Failed to change password by admin:", error);
//         throw error;
//     }
// };
// // ============================================
// // ✅ ویرایش اطلاعات مشتری حقیقی (NATURAL)
// // ============================================
// /**
//  * به‌روزرسانی Customer Natural By Admin
//  * @param customerId - (any)
//  * @param data - (any)
//  * @returns پاسخ سرور
//  */
// export const UpdateCustomerNaturalByAdmin = async (customerId: any, data: any) => {
//     const res = await api.put(
//         `/managerPanel/customer/updateCustomerNaturalByAdmin?customerId=${customerId}`,
//         data
//     );
//     return res.data;
// };

// // ============================================
// // ✅ دریافت طرح‌های مشتری
// // ============================================
// /**
//  * دریافت Customer Plans
//  * @param customerId - (any)
//  * @returns پاسخ سرور
//  */
// export const GetCustomerPlans = async (customerId: any) => {
//     try {
//         const res = await api.get(
//             "/managerPanel/customer/getCustomerPlans",
//             {
//                 params: { customerId },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };

// // ============================================
// // ✅ انتخاب طرح پیش‌فرض برای مشتری
// // ============================================
// /**
//  * به‌روزرسانی Default Street Plan For Customer
//  * @param customerId - (any)
//  * @param planId - (any)
//  * @returns پاسخ سرور
//  */
// export const SetDefaultStreetPlanForCustomer = async (
//     customerId: any,
//     planId: any
// ) => {
//     try {
//         const res = await api.get(
//             "/managerPanel/customer/setDefaultStreetPlanForCustomer",
//             {
//                 params: { customerId, planId },
//             }
//         );
//         return res.data;
//     } catch (err) {
//         throw err;
//     }
// };

// // ============================================
// // ✅ بستن حساب‌های مشتریان حقیقی از طریق اکسل
// // POST /api/managerPanel/importExcell/closingBankAccounts
// // ============================================
// export const ClosingBankAccountsExcel = async (
//     file: File,
//     fileName: string
// ): Promise<Blob> => {
//     if (!(file instanceof File)) {
//         throw new Error("فایل انتخاب‌شده معتبر نیست");
//     }

//     const formData = new FormData();
//     formData.append("file", file, file.name);

//     const res = await api.post(
//         "/managerPanel/importExcell/closingBankAccounts",
//         formData,
//         {
//             params: { fileName },
//             responseType: "blob",
//             // ✅ مهم: Content-Type را دستی ست نکنید.
//             // اگر axios instance شما default روی JSON است، این خط آن را حذف می‌کند
//             // تا axios خودش multipart/form-data + boundary را بگذارد.
//             headers: {
//                 Accept:
//                     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//                 "Content-Type": undefined as unknown as string,
//             },
//         }
//     );

//     return res.data;
// };
// // ============================================
// // ✅ لیست فایل‌های اکسل آپلود شده
// // GET /api/managerPanel/importExcell/search
// // ============================================
// export interface ExcelFileItem {
//   id: number;
//   uploadDate: string;
//   fileName: string;
//   category: string | null;
//   size: number;
//   fileExtension: string;
// }

// export interface GetExcelFileListParams {
//   page?: number;
//   size?: number;
//   sortField?: string;
//   sortDirection?: string;
// }

// export const GetExcelFileList = async ({
//   page = 0,
//   size = 10,
//   sortField = "DECS",
//   sortDirection = "DECS",
// }: GetExcelFileListParams = {}): Promise<
//   ApiResponse<ExcelFileItem[]> & { count: number }
// > => {
//   const params = new URLSearchParams();
//   params.append("page", String(page));
//   params.append("size", String(size));
//   params.append("sortField", sortField);
//   params.append("sortDirection", sortDirection);

//   const res = await api.get(
//     `/managerPanel/importExcell/search?${params.toString()}`
//   );
//   return res.data;
// };

// // ============================================
// // ✅ دانلود فایل اکسل آپلود شده
// // GET /api/managerPanel/importExcell/download/?uploadExcelFileId={id}
// // ============================================
// export const DownloadExcelFile = async (
//   uploadExcelFileId: number
// ): Promise<Blob> => {
//   const res = await api.get(
//     `/managerPanel/importExcell/download/?uploadExcelFileId=${uploadExcelFileId}`,
//     {
//       responseType: "blob",
//       headers: {
//         Accept: "application/octet-stream",
//       },
//     }
//   );
//   return res.data;
// };

import api from "../../../config/api/index.js"
import type { ApiResponse } from "../auth/types.js"

// core/services/admins/customer/api.ts

interface IGetCustomerListParams {
    search?: string
    type?: string
    page?: number
    size?: number
    sortField?: string
    sortDirection?: "ACS" | "DESC" | string
}

// core/services/admins/customer/api.ts

// ============== GET - گزارش عملکرد مشتری ==============
export interface CustomerPerformanceParams {
    customerId: number;
    page?: number;
    size?: number;
    sortField?: string;
    sortDirection?: 'ASC' | 'DESC';
}

// ============================================
// ✅ آپلود لیست مشتریان دارای طرح (اکسل)
// POST /api/managerPanel/importExcell/getListOfCustomersWithPlan
// ============================================
export const UploadCustomerAverageExcel = async (
    file: File,
    fileName: string
): Promise<Blob> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await api.post(
            "/managerPanel/importExcell/getListOfCustomersWithPlan",
            formData,
            {
                params: { fileName },
                responseType: "blob",
                timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/octet-stream",
                },
            }
        );

        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ آپلود اکسل پرداخت مشتری‌ها
// POST /api/managerPanel/importExcell/importCustomerPayments
// ============================================
export const ImportCustomerPaymentsExcel = async (
    file: File,
    fileName: string
): Promise<Blob> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await api.post(
            "/managerPanel/importExcell/importCustomerPayments",
            formData,
            {
                params: { fileName },
                responseType: "blob",
                timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/octet-stream",
                },
            }
        );

        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ دریافت لیست مشتریان دارای مبلغ قابل پرداخت
// GET /api/managerPanel/importExcell/listOfCustomerPayments
// ============================================
export const DownloadListOfCustomerPayments = async (): Promise<Blob> => {
    try {
        const res = await api.get(
            "/managerPanel/importExcell/listOfCustomerPayments",
            {
                responseType: "blob",
                timeout: 0,   // ✅ دانلود سنگین
                headers: {
                    Accept: "application/octet-stream",
                },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

export interface CustomerPerformanceItem {
    id: number;
    customer: {
        id: number;
        customerCode: number;
        customerType: 'NATURAL' | 'LEGAL' | 'CHARITY';
        naturalInfo?: {
            nickname?: string;
            firstName?: string;
            lastName?: string;
            nationalId?: string;
            birthDate?: number;
            gender?: 'MALE' | 'FEMALE';
        };
        legalInfo?: {
            name?: string | null;
            brand?: string | null;
            companyNationalId?: string | null;
            managerName?: string | null;
            managerMobileNumber?: string | null;
            phoneNumber?: string | null;
            charity?: boolean;
            employeeCount?: number;
        };
        mobileNumber?: string;
        defaultVisitor?: boolean;
        visitorSet?: boolean;
    };
    releaseDate: string;
    paymentDate: string | null;
    previousMonthAverage: number;
    diamondReceived: number;
    interestReceived: number;
    benefitCardReceived: number;
    amount: number;
    payed: boolean;
}

/**
 * دریافت Customer Performance
 * @param params - (CustomerPerformanceParams)
 * @returns پاسخ سرور
 */
export const GetCustomerPerformanceApi = async (
    params: CustomerPerformanceParams
): Promise<ApiResponse<CustomerPerformanceItem[]>> => {
    try {
        const response = await api.get<ApiResponse<CustomerPerformanceItem[]>>(
            `managerPanel/customer/CustomerPerformance`,
            { params }
        );
        return response.data;
    } catch (error) {
        console.error("Failed to get customer performance:", error);
        throw error;
    }
};

/**
 * دریافت Customer List
 * @param {
    search = ""
 * @param type = "ALL"
 * @param page = 0
 * @param size = 25
 * @param sortField = "id"
 * @param sortDirection = "ASC"
 * @param } - (IGetCustomerListParams = {})
 * @returns پاسخ سرور
 */
export const GetCustomerList = async ({
    search = "",
    type = "ALL",
    page = 0,
    size = 25,
    sortField = "id",
    sortDirection = "ASC",
}: IGetCustomerListParams = {}) => {
    const params = new URLSearchParams();

    params.append("type", type);
    params.append("page", String(page));
    params.append("size", String(size));
    params.append("sortField", sortField);
    params.append("sortDirection", sortDirection);

    if (search.trim()) {
        params.append("search", search.trim());
    }

    const res = await api.get(
        `/managerPanel/customer/search?${params.toString()}`
    );
    return res.data;
};

// ============================================
// ✅ آپلود Customer Excel (افتتاح حساب)
// POST /api/managerPanel/importExcell/openingBankAccount
// ============================================
export const UploadCustomerExcel = async (
    file: File,
    fileName: string
): Promise<Blob> => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await api.post(
        "/managerPanel/importExcell/openingBankAccount",
        formData,
        {
            params: { fileName },
            responseType: "blob",
            timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/octet-stream",
            },
        }
    );

    return res.data;
};

// ============================================
// ✅ آپلود Customer Average Visitor Excel
// POST /api/managerPanel/importExcell/customerAverageVisitor
// ============================================
export const UploadCustomerAverageVisitorExcel = async (
    file: File,
    fileName: string
): Promise<any> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await api.post(
            "/managerPanel/importExcell/customerAverageVisitor",
            formData,
            {
                params: { fileName },
                timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ تغییر بازاریاب مشتری
// ============================================
/**
 * به‌روزرسانی Customer Visitor
 * @param customerId - (any)
 * @param newVisitorCode - (any)
 * @returns پاسخ سرور
 */
export const ChangeCustomerVisitor = async (
    customerId: any,
    newVisitorCode: any
) => {
    try {
        const res = await api.get(
            "/managerPanel/customer/changeVisitor",
            {
                params: { customerId, newVisitorCode },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ آپلود Average Natural Customer Excel
// POST /api/managerPanel/importExcell/averageNaturalCustomer
// ============================================
export const UploadAverageNaturalCustomerExcel = async (
    file: File,
    fileName: string
): Promise<Blob> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await api.post(
            "/managerPanel/importExcell/averageNaturalCustomer",
            formData,
            {
                params: { fileName },
                responseType: "blob",
                timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res.data;
    } catch (err) {
        throw err;
    }
};

/**
 * به‌روزرسانی Customer Active
 * @param { customerId
 * @param status } - (any)
 * @returns پاسخ سرور
 */
export const ChangeCustomerActive = async ({ customerId, status }: any) => {
    try {
        const res = await api.get(
            "/managerPanel/customer/activeDeActive",
            {
                params: { customerId, status },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ دریافت اطلاعات کامل یک مشتری
// ============================================
/**
 * دریافت Customer Info
 * @param customerId - (number)
 * @returns پاسخ سرور
 */
export const GetCustomerInfo = async (customerId: number) => {
    try {
        const res = await api.get(
            "/managerPanel/customer/getCustomerInfo",
            {
                params: { customerId },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const ChangePasswordByAdminApi = async (data: {
    customerId: number;
    password: string;
}): Promise<any> => {
    try {
        const response = await api.post(
            "managerPanel/legal/changePasswordByAdmin",
            data
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to change password by admin:", error);
        throw error;
    }
};

// ============================================
// ✅ ویرایش اطلاعات مشتری حقیقی (NATURAL)
// ============================================
/**
 * به‌روزرسانی Customer Natural By Admin
 * @param customerId - (any)
 * @param data - (any)
 * @returns پاسخ سرور
 */
export const UpdateCustomerNaturalByAdmin = async (customerId: any, data: any) => {
    const res = await api.put(
        `/managerPanel/customer/updateCustomerNaturalByAdmin?customerId=${customerId}`,
        data
    );
    return res.data;
};

// ============================================
// ✅ دریافت طرح‌های مشتری
// ============================================
/**
 * دریافت Customer Plans
 * @param customerId - (any)
 * @returns پاسخ سرور
 */
export const GetCustomerPlans = async (customerId: any) => {
    try {
        const res = await api.get(
            "/managerPanel/customer/getCustomerPlans",
            {
                params: { customerId },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ انتخاب طرح پیش‌فرض برای مشتری
// ============================================
/**
 * به‌روزرسانی Default Street Plan For Customer
 * @param customerId - (any)
 * @param planId - (any)
 * @returns پاسخ سرور
 */
export const SetDefaultStreetPlanForCustomer = async (
    customerId: any,
    planId: any
) => {
    try {
        const res = await api.get(
            "/managerPanel/customer/setDefaultStreetPlanForCustomer",
            {
                params: { customerId, planId },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ بستن حساب‌های مشتریان حقیقی از طریق اکسل
// POST /api/managerPanel/importExcell/closingBankAccounts
// ============================================
export const ClosingBankAccountsExcel = async (
    file: File,
    fileName: string
): Promise<Blob> => {
    if (!(file instanceof File)) {
        throw new Error("فایل انتخاب‌شده معتبر نیست");
    }

    const formData = new FormData();
    formData.append("file", file, file.name);

    const res = await api.post(
        "/managerPanel/importExcell/closingBankAccounts",
        formData,
        {
            params: { fileName },
            responseType: "blob",
            timeout: 0,   // ✅ بدون محدودیت (آپلود سنگین)
            // ✅ مهم: Content-Type را دستی ست نکنید.
            // اگر axios instance شما default روی JSON است، این خط آن را حذف می‌کند
            // تا axios خودش multipart/form-data + boundary را بگذارد.
            headers: {
                Accept:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "Content-Type": undefined as unknown as string,
            },
        }
    );

    return res.data;
};

// ============================================
// ✅ لیست فایل‌های اکسل آپلود شده
// GET /api/managerPanel/importExcell/search
// ============================================
export interface ExcelFileItem {
    id: number;
    uploadDate: string;
    fileName: string;
    category: string | null;
    size: number;
    fileExtension: string;
}

export interface GetExcelFileListParams {
    page?: number;
    size?: number;
    sortField?: string;
    sortDirection?: string;
}

export const GetExcelFileList = async ({
    page = 0,
    size = 10,
    sortField = "DECS",
    sortDirection = "DECS",
}: GetExcelFileListParams = {}): Promise<
    ApiResponse<ExcelFileItem[]> & { count: number }
> => {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("size", String(size));
    params.append("sortField", sortField);
    params.append("sortDirection", sortDirection);

    const res = await api.get(
        `/managerPanel/importExcell/search?${params.toString()}`
    );
    return res.data;
};

// ============================================
// ✅ دانلود فایل اکسل آپلود شده
// GET /api/managerPanel/importExcell/download/?uploadExcelFileId={id}
// ============================================
export const DownloadExcelFile = async (
    uploadExcelFileId: number
): Promise<Blob> => {
    const res = await api.get(
        `/managerPanel/importExcell/download/?uploadExcelFileId=${uploadExcelFileId}`,
        {
            responseType: "blob",
            timeout: 0,   // ✅ دانلود سنگین
            headers: {
                Accept: "application/octet-stream",
            },
        }
    );
    return res.data;
};